import React from "react";
import { useLocation } from "react-router-dom";
import AgentForm from "../Common/AgentForm";

export default function EditAgent() {
  const location = useLocation();
  const agentId = location.state?.id;

  return <AgentForm mode="edit" agentId={agentId} />;
}
